import React from 'react';
import BaseIcon from '@/components/icons/BaseIcon';

const ChevronUpIcon: React.FC = () => (
  <BaseIcon>
    <path d="m18 15-6-6-6 6" />
  </BaseIcon>
);

export default ChevronUpIcon;
